(function (angular) {
    "use strict";

    angular.module('ApiUtils.khauth', [
        'ApiUtils.khauth.auth'
    ])

})(angular);
